export default {
  gbpt: "Presupuesto Global Por Tipo",
  budgetDistribution: "Distribución del Presupuesto",
  worksModule: "CAO",
  orderId: "Nro. de orden ",
  name: "Nombre",
  location: "Ubicación Tecnica",
  dateCreated: "Fecha de Creación",
  dueDate: "Fecha Limite",
  whoReceive: "¿Quien Recibe?",
  whoSent: "¿Quien Entrega?",
  search: "Buscar",
  newWork: "Nueva Obra",
  description: "Descripción",
  cancel: "Cancelar",
  save: "Guardar",
  modulesbtn: "Módulos"
};
